<template>
  <div class="my-message all-order-content">
    <div class="breadcrumb" style="margin-bottom: 20px;">升级版本</div>
    <div class="right-content">
      <el-form ref="upgradeFrom" label-width="160px" :model="upgradeFrom" :rules="rules" class="demo-form-inline">
        <el-form-item label="选择系统平台：" prop="terminalType">
          <!-- <el-checkbox-group v-model="terminalType" v-if="!disabled">
            <el-checkbox-button label="Android" value="Android"></el-checkbox-button>
            <el-checkbox-button label="IOS" value="IOS"></el-checkbox-button>
          </el-checkbox-group> -->
          <el-radio-group v-model="terminalType" v-if="!disabled" @input="terminalTypeChange">
            <el-radio-button label="Android" value="Android"></el-radio-button>
            <el-radio-button l label="IOS" value="IOS"></el-radio-button>
          </el-radio-group>
          <div v-else>{{ terminalType }}</div>
        </el-form-item>
        <el-form-item label="下载地址：" prop="downloadUrl">
          <el-input v-model="upgradeFrom.downloadUrl" placeholder="请输入下载地址" clearable :disabled="disabled"></el-input>
        </el-form-item>
        <el-form-item label="版本号：" prop="version">
          <el-input v-model="upgradeFrom.version" placeholder="V*.**.*" clearable :disabled="disabled"></el-input>
        </el-form-item>
        <el-form-item label="升级类型：" prop="method">
          <el-select v-model="upgradeFrom.method" placeholder="请选择类型" clearable :disabled="disabled">
            <el-option v-for="(item, index) in upgradeList" :label="item.label" :value="item.value" :key="'aaa' + index"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="提示频次：" prop="frequency" v-if="upgradeFrom.method == 3">
          <el-select v-model="upgradeFrom.frequency" placeholder="请选择提示频次" clearable :disabled="disabled">
            <el-option v-for="(item, index) in frequencyList" :label="item.label" :value="item.value" :key="'bbb' + index"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="升级提示语：" prop="context">
          <el-input type="textarea" :rows="7" placeholder="请输入升级提示语" v-model="upgradeFrom.context" clearable maxlength="100" show-word-limit :disabled="disabled">
          </el-input>
        </el-form-item>
        <el-form-item label="发布时间：" prop="sysUpTime">
          <el-date-picker :disabled="disabled" v-model="upgradeFrom.sysUpTime" type="datetime" :picker-options="pickerOptions0" placeholder="选择发布时间" format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="兼容最低版本：" prop="compatibleMinVersion">
          <el-select v-model="upgradeFrom.compatibleMinVersion" placeholder="请选择版本" clearable :disabled="disabled">
            <el-option v-for="(a, i) in versionList" :key="i" :label="a.name" :value="a.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="save" round style="float:right;margin-right:200px;" v-if="!disabled">确 定</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>
<script>
import uploadWebImg from '@/utils/uploadWebImg'
import { addAppPushRecord, editInfoAppPushRecord, getHistoryVersion } from '@/api/crm'
import { resolve } from 'path'
export default {
  name: 'upgradeVersion-detail',
  data () {
    return {
      rules: {
        downloadUrl: [
          { required: true, message: '请输入下载地址', trigger: 'blur' }
        ],
        version: [
          { required: true, message: '请输入版本号', trigger: 'blur' }
        ],
        context: [
          { required: true, message: '请输入升级提示语', trigger: 'blur' }
        ],
        method: [
          { required: true, message: '请选择升级类型', trigger: 'change' }
        ],
        frequency: [
          { required: true, message: '请选择提示频次', trigger: 'change' }
        ],
        sysUpTime: [
          { required: true, message: '请选择发布时间', trigger: 'change' }
        ]
        // compatibleMinVersion: [
        //   { required: true, message: '请选择兼容最低版本', trigger: 'change' }
        // ]
      },
      versionList: [],
      terminalType: '',
      upgradeFrom: {
        compatibleMinVersion: '',
        context: '',
        downloadUrl: '',
        frequency: '',
        method: '',
        sysUpTime: '',
        terminalType: '',
        version: ''
      },
      pickerOptions0: {
        disabledDate (time) {
          return time.getTime() < Date.now() - 8.64e7
        }
      },
      upgradeList: [{
        label: '不提示升级',
        value: 1
      }, {
        label: '弱提示升级',
        value: 2
      }, {
        label: '强提示升级',
        value: 3
      }, {
        label: '强制升级',
        value: 4
      }],
      frequencyList: [{
        label: '启动APP提示',
        value: 1
      }, {
        label: '一天一次',
        value: 2
      }, {
        label: '三天一次',
        value: 3
      }, {
        label: '七天一次',
        value: 4
      }],
      tableDataList: [],
      disabled: false
    }
  },
  async created () {
    if (this.terminalType) {
      await this.getHistoryVersionList()
    }
    if (this.$route.query.detail) {
      this.upgradeFrom = JSON.parse(this.$route.query.detail)
      // this.terminalType = this.upgradeFrom.terminalType.split(',')
      this.terminalType = this.upgradeFrom.terminalType
    }
    if (this.$route.query.type) {
      this.disabled = true
    }
  },
  methods: {
    // 选择类型
    terminalTypeChange () {
      this.getHistoryVersionList()
    },
    // 获取兼容最低版本
    async getHistoryVersionList () {
      await getHistoryVersion(this.terminalType).then(res => {
        if (res.data.success) {
          this.versionList = res.data.data
        }
      })
    },
    save () {
      this.$refs.upgradeFrom.validate((valid) => {
        if (!valid) {
          return
        }
        if (!this.terminalType) {
          this.$message.error('请选择系统平台')
          return
        }
        // let currentTime = new Date()
        // let compareTime = new Date(this.upgradeFrom.sysUpTime)
        // if (compareTime > currentTime) {
        //   this.$message.error('请选择系统平台')
        //   return
        // }
        this.upgradeFrom.terminalType = this.terminalType
        if (!this.upgradeFrom.id) {
          addAppPushRecord(this.upgradeFrom).then(res => {
            if (res.data.success) {
              this.$notify({
                title: '成功',
                message: '保存成功',
                type: 'success'
              })
              this.$router.go(-1)
            }
          }
          )
        } else {
          editInfoAppPushRecord(this.upgradeFrom).then(res => {
            if (res.data.success) {
              if (res.data.success) {
                this.$notify({
                  title: '成功',
                  message: '修改成功',
                  type: 'success'
                })
                this.$router.go(-1)
              }
            }
          })
        }
      })
    }
  }
}
</script>

<style scoped lang="less">
@deep: ~">>>";

.el-textarea {
  width: 300px !important;
}

/deep/ .el-input {
  width: 255px !important;
}

@{deep} .pc_detail {
  width: 100%;

  img {
    width: 100%;
  }
}

@{deep} .hide_uploadbtn .el-upload--picture-card {
  display: none;
  /* 上传按钮隐藏 */
}

// @{deep} .ql-container .ql-snow {
//   height: 500px;
// }
@{deep} .ql-container {
  height: auto !important;
}

.quill-editor {
  width: 70%;

  @{deep} .ql-editor {
    min-height: 400px;
  }

  @{deep} .ql-toolbar {
    .ql-picker-label {
      height: auto;
    }

    .ql-picker.ql-expanded .ql-picker-options {
      top: auto;
    }
  }
}

@{deep} .el-cascader {
  line-height: 0;
}
</style>
